import { defineMessages } from 'react-intl';
import { isMatterTranslationsEnabled } from '../../utils/intlUtils';

const intlMessages = defineMessages({
  selectFiles: { defaultMessage: 'Select files to upload' },
  invalidFileType: { defaultMessage: 'invalid filetype' },
  uploadEmailAsZipEml: {
    defaultMessage:
      'Upload this email thread as EML files under “Supporting files” in the project',
  },
  uploadEmailAsZipEml_Matter: {
    defaultMessage:
      'Upload this email thread as EML files under “Supporting files” in the matter',
  },
  emlFileLink: {
    defaultMessage: 'What is an EML file?',
  },
});

const messages = {
  ...intlMessages,
  get uploadEmailAsZipEml() {
    if (isMatterTranslationsEnabled) {
      return intlMessages.uploadEmailAsZipEml_Matter;
    } else {
      return intlMessages.uploadEmailAsZipEml;
    }
  },
};

export default messages;
